module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/calendar-link.93d0dcb0.svg";